import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone";
import numeral from "numeral";
import TipoDocFrame from './TipoDocFrame';
import CtaCorrenteFrame from './CtaCorrenteFrame';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;

export const OPCOES_COMBO = [
  {
    key: 'E',
    label: 'Entrada'
  },
  {
    key: 'S',
    label: 'Saída'
  },
]

export const OPCOES_COMBO_PARC = [
  {
    key: 'A',
    label: 'ABERTO'
  },
  {
    key: 'P',
    label: 'PAGO'
  },
]

export default class TituloParcelaForm extends Component {
  state = {
    editando: false,
    formParcDisabled: true,
    condInformada: false,

    listaParcelas: [],
    valor_Total: 0,
    vlrTotalParc: 0,
    vlrDifParc: 0,

    registroParcela: {
      tparc_parcela: 0,
      tparc_data_parcela: moment().format('DD/MM/YYYY'),
      tparc_tipo_doc: { key: '0', label: '', },
      tparc_conta_corrente: { key: '0', label: '', },
      tparc_valor: 0,
      tparc_situacao: { key: 'A', label: 'ABERTO', },
      tparc_obs: '',
      td_descricao: '',
      cc_descricao: '',
      situacao_parcela: '',
      pgto_vlr_desconto: 0,
      pgto_vlr_acrescimo: 0,
      pgto_vlr_pago: 0,
      pgto_vlr_restante: 0,
      pgto_data: moment().format('DD/MM/YYYY'),
      pgto_cta_corrente: '',
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props !== propsAnterior) {
      // console.log('componentDidUpdate: ', this.props);

      this.setState({
        // registro: this.props.registroSelecionado.dados,
        listaParcelas: this.props.listaParcelas ? this.props.listaParcelas : [],
        valor_Total: this.props.valor_Total ? this.props.valor_Total : [],
        condInformada: this.props.condPagto && this.props.condPagto.key === String(this.state.usuario.par_cond_pagto_informada) ? true : false,
        registroParcela: {
          tparc_parcela: 0,
          tparc_data_parcela: moment().format('DD/MM/YYYY'),
          tparc_tipo_doc: { key: '0', label: '', },
          tparc_conta_corrente: { key: '0', label: '', },
          tparc_valor: 0,
          tparc_situacao: { key: 'A', label: 'ABERTO', },
          tparc_obs: '',
          td_descricao: '',
          cc_descricao: '',
          situacao_parcela: '',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: 0,
          pgto_vlr_restante: 0,
          pgto_data: moment().format('DD/MM/YYYY'),
          pgto_cta_corrente: '',
        }

      }, () => {

      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  onDateVencChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registroParcela } = this.state;
    registroParcela['tparc_data_parcela'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ tparc_data_parcela: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDatePagtoChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registroParcela } = this.state;
    registroParcela['pgto_data'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ pgto_data: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }



  onChangeParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });
  };

  onChangeSituacaoParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });
    this.calculaVlrParc(value);
  };

  onChangeTipoDoc = event => {
    const { registroParcela } = this.state;
    registroParcela['tparc_tipo_doc'] = event.tparc_tipo_doc;
    this.setState(event);
  }

  onChangeCtaCorrente = event => {
    const { registroParcela } = this.state;
    registroParcela['tparc_conta_corrente'] = event.tparc_conta_corrente;
    this.setState(event);
  }

  onChangeValorParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({
      [id]: value
    });
    this.calculaVlrParc(this.state.registroParcela.tparc_situacao);
  };

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.props.valor_Total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  calculaVlrParc = (situacao) => {
    let pgto_vlr_pago = this.state.registroParcela.tparc_valor;
    if (situacao.key === 'P') {
      pgto_vlr_pago = (parseFloat(this.state.registroParcela.tparc_valor) + parseFloat(this.state.registroParcela.pgto_vlr_acrescimo) - parseFloat(this.state.registroParcela.pgto_vlr_desconto)).toFixed(2);
    }
    this.setState({
      registroParcela: {
        ...this.state.registroParcela,
        pgto_vlr_acrescimo: situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0,
        pgto_vlr_desconto: situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0,
        pgto_vlr_pago,
      }
    });

  }

  onAdicionarClick = registro => {
    let registroParcela = {
      tparc_parcela: this.state.listaParcelas.length + 1,
      tparc_data_parcela: moment().format('DD/MM/YYYY'),
      tparc_tipo_doc: {
        key: '0',
        label: '',
      },
      tparc_conta_corrente: {
        key: '0',
        label: '',
      },
      tparc_situacao: { key: 'A', label: 'ABERTO' },
      tparc_valor: 0,
      tparc_obs: '',
      td_descricao: '',
      cc_descricao: '',
      situacao_parcela: 'ABERTO',
      pgto_vlr_desconto: 0,
      pgto_vlr_acrescimo: 0,
      pgto_vlr_pago: 0,
      pgto_vlr_restante: 0,
      pgto_data: moment().format('DD/MM/YYYY'),
      pgto_cta_corrente: '',
    }

    this.setState({
      registroParcela,
      formParcDisabled: false,
      activeKey: "parcela",
    });
  }

  onOKParcClick = (value) => {
    // console.log('this.state.registroParcela: ', this.state.registroParcela);

    if (this.state.registroParcela.tparc_situacao.key === 'P') {
      const dataAtual = moment().format('YYYY-MM-DD');
      const dataPagto = moment(this.state.registroParcela.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (dataPagto > dataAtual) {
        Modal.warning({ title: 'Aviso!', content: 'Data de Pagamento da Parcela maior que data atual.', });
        return;
      }
    }

    if ((this.state.registroParcela.tparc_valor) && (parseFloat(this.state.registroParcela.tparc_valor) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Valor da Parcela menor que zero.', });
      return;
    }

    if ((this.state.registroParcela.tparc_situacao.key === 'P') && (this.state.registroParcela.pgto_vlr_pago) && (parseFloat(this.state.registroParcela.pgto_vlr_pago) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Valor do Pagamento menor que zero.', });
      return;
    }

    if ((!this.state.registroParcela.tparc_tipo_doc) || (this.state.registroParcela.tparc_tipo_doc.key === '0') || (this.state.registroParcela.tparc_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registroParcela.tparc_conta_corrente) || (this.state.registroParcela.tparc_conta_corrente.key === '0') || (this.state.registroParcela.tparc_conta_corrente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente', });
      return;
    }


    const iInd = this.state.listaParcelas ? this.state.listaParcelas.findIndex(registro => String(registro.tparc_parcela) === String(this.state.registroParcela.tparc_parcela)) : -1;

    if (iInd >= 0) {

      this.state.listaParcelas[iInd].tparc_data_parcela = moment(this.state.registroParcela.tparc_data_parcela, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.state.listaParcelas[iInd].tparc_tipo_doc = this.state.registroParcela.tparc_tipo_doc.key;
      this.state.listaParcelas[iInd].tparc_conta_corrente = this.state.registroParcela.tparc_conta_corrente.key;
      this.state.listaParcelas[iInd].tparc_situacao = this.state.registroParcela.tparc_situacao.key;
      this.state.listaParcelas[iInd].tparc_valor = this.state.registroParcela.tparc_valor;
      this.state.listaParcelas[iInd].tparc_obs = this.state.registroParcela.tparc_obs;
      this.state.listaParcelas[iInd].td_descricao = this.state.registroParcela.tparc_tipo_doc.label;
      this.state.listaParcelas[iInd].cc_descricao = this.state.registroParcela.tparc_conta_corrente.label;
      this.state.listaParcelas[iInd].situacao_parcela = this.state.registroParcela.tparc_situacao.label;
      this.state.listaParcelas[iInd].pgto_vlr_desconto = this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0;
      this.state.listaParcelas[iInd].pgto_vlr_acrescimo = this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0;
      this.state.listaParcelas[iInd].pgto_vlr_pago = this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_pago : 0;
      this.state.listaParcelas[iInd].pgto_vlr_restante = this.state.registroParcela.pgto_vlr_restante;
      this.state.listaParcelas[iInd].pgto_data = this.state.registroParcela.tparc_situacao.key === 'P' ? moment(this.state.registroParcela.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
      this.state.listaParcelas[iInd].pgto_cta_corrente = this.state.registroParcela.tparc_conta_corrente.key;

    } else {

      this.state.listaParcelas.push({
        tparc_parcela: this.state.registroParcela.tparc_parcela,
        tparc_data_parcela: moment(this.state.registroParcela.tparc_data_parcela, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        tparc_tipo_doc: this.state.registroParcela.tparc_tipo_doc.key,
        tparc_conta_corrente: this.state.registroParcela.tparc_conta_corrente.key,
        tparc_valor: this.state.registroParcela.tparc_valor,
        tparc_situacao: this.state.registroParcela.tparc_situacao.key,
        tparc_obs: this.state.registroParcela.tparc_obs,
        td_descricao: this.state.registroParcela.tparc_tipo_doc.label,
        cc_descricao: this.state.registroParcela.tparc_conta_corrente.label,
        situacao_parcela: this.state.registroParcela.tparc_situacao.label,
        pgto_vlr_desconto: this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0,
        pgto_vlr_acrescimo: this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0,
        pgto_vlr_pago: this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_pago : 0,
        pgto_vlr_restante: this.state.registroParcela.pgto_vlr_restante,
        pgto_data: this.state.registroParcela.tparc_situacao.key === 'P' ? moment(this.state.registroParcela.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        pgto_cta_corrente: this.state.registroParcela.tparc_conta_corrente.key,
      });

    }


    this.setState({
      formParcDisabled: true,

      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: moment().format('DD/MM/YYYY'),
        tparc_tipo_doc: { key: '0', label: '', },
        tparc_conta_corrente: { key: '0', label: '', },
        tparc_valor: 0,
        tparc_situacao: '',
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: moment().format('DD/MM/YYYY'),
        pgto_cta_corrente: '',
      }
    },
      this.calculaTotalParc()
    );

  };

  onEditarParcelaClick = registro => {
    // console.log('PARCELA: ', registro);

    let registroParcela = {
      tparc_parcela: registro.tparc_parcela,
      tparc_data_parcela: moment(registro.tparc_data_parcela, 'YYYY-MM-DD').format('DD/MM/YYYY'),
      tparc_tipo_doc: {
        key: String(registro.tparc_tipo_doc),
        label: registro.td_descricao,
      },
      tparc_conta_corrente: {
        key: String(registro.tparc_conta_corrente),
        label: registro.cc_descricao,
      },
      tparc_situacao: {
        key: registro.tparc_situacao,
        label: registro.situacao_parcela,
      },
      tparc_valor: registro.tparc_valor,
      tparc_obs: registro.tparc_obs ? registro.tparc_obs : '',
      td_descricao: registro.td_descricao,
      cc_descricao: registro.cc_descricao,
      situacao_parcela: registro.situacao_parcela,
      pgto_vlr_desconto: registro.pgto_vlr_desconto,
      pgto_vlr_acrescimo: registro.pgto_vlr_acrescimo,
      pgto_vlr_pago: registro.pgto_vlr_pago && registro.pgto_vlr_pago === 0 ? registro.pgto_vlr_pago : registro.tparc_valor,
      pgto_vlr_restante: registro.pgto_vlr_restante,
      pgto_data: registro.pgto_data && registro.pgto_data !== '' ? moment(registro.pgto_data, 'YYYY-MM-DD').format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
      pgto_cta_corrente: registro.pgto_cta_corrente,
    }

    this.setState({
      registroParcela,
      formParcDisabled: false,
    });

  };

  onCancelarParcClick = (value) => {
    this.setState({
      formParcDisabled: true,
      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: moment().format('DD/MM/YYYY'),
        tparc_tipo_doc: { key: '0', label: '', },
        tparc_conta_corrente: { key: '0', label: '', },
        tparc_valor: 0,
        tparc_situacao: '',
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: moment().format('DD/MM/YYYY'),
        pgto_cta_corrente: '',
      }
    });
  };



  renderValor = (tparc_valor) => {
    return (
      <span> {numeral(parseFloat(tparc_valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderAcoesParcelas = (registro) => {
    return (
      <Tooltip title="Editar">
        <Button type="primary" size="small" onClick={() => this.onEditarParcelaClick(registro)} icon="edit" />
      </Tooltip>
    );
  };





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharClick, visivel } = this.props;

    const { tparc_parcela, tparc_situacao, tparc_data_parcela, tparc_valor, pgto_vlr_desconto,
      pgto_vlr_acrescimo, pgto_vlr_pago, tparc_tipo_doc, pgto_data, tparc_conta_corrente
    } = this.state.registroParcela;

    const { valor_Total, listaParcelas, vlrTotalParc, vlrDifParc, formParcDisabled, condInformada } = this.state;

    // console.log('TituloParcelaForm.this.state: ', this.state);

    return (
      <Modal
        title={"Editar Parcelas"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharClick}
        footer={null}
        width={"50%"}
        style={{ top: 10 }}
      >
        <div>
          <Row style={{}}>
            <Row style={{}}>
              <Col xs={24}>
                <Col xs={24} sm={6} className="camposEspacoDireita">
                  <span>Parcela</span>
                  <InputForm
                    id="tparc_parcela"
                    ref="tparc_parcela"
                    onChange={this.onChangeParcela}
                    value={tparc_parcela}
                    disabled={true}
                  />
                </Col>

                <Col xs={24} sm={6} className="camposEspacoDireita">
                  <span>Situação</span>
                  <InputForm
                    type="select"
                    id="tparc_situacao"
                    ref="tparc_situacao"
                    value={tparc_situacao}
                    placeholder="Selecione"
                    onChange={this.onChangeSituacaoParcela}
                    data={OPCOES_COMBO_PARC}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                    disabled={formParcDisabled}
                  />
                </Col>


                <Col xs={24} sm={6} style={{ marginTop: 4 }} className="camposEspacoDireita">
                  <span>Data Vencimento</span>
                  <DatePicker
                    onChange={this.onDateVencChange}
                    format="DD/MM/YYYY"
                    showToday={true}
                    allowClear={false}
                    value={moment(tparc_data_parcela, "DD/MM/YYYY", true)}
                    style={{ width: "100%" }}
                    disabled={formParcDisabled}
                  />
                </Col>
                {tparc_situacao.key === 'A' ? null : (
                  <Col xs={24} sm={6} style={{ marginTop: 4 }}>
                    <span>Data Pagto</span>
                    <DatePicker
                      onChange={this.onDatePagtoChange}
                      format="DD/MM/YYYY"
                      showToday={true}
                      allowClear={false}
                      value={moment(pgto_data, "DD/MM/YYYY", true)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                )}
              </Col>

              <Col xs={24}>
                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Valor Parcela</span>
                  <InputForm
                    type="number"
                    id="tparc_valor"
                    ref="tparc_valor"
                    value={tparc_valor}
                    onChange={this.onChangeValorParcela}
                    disabled={formParcDisabled}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Valor Desconto</span>
                  <InputForm
                    type="number"
                    id="pgto_vlr_desconto"
                    ref="pgto_vlr_desconto"
                    value={pgto_vlr_desconto}
                    onChange={this.onChangeValorParcela}
                    disabled={tparc_situacao.key === 'A'}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Valor Acréscimo</span>
                  <InputForm
                    type="number"
                    id="pgto_vlr_acrescimo"
                    ref="pgto_vlr_acrescimo"
                    value={pgto_vlr_acrescimo}
                    onChange={this.onChangeValorParcela}
                    disabled={tparc_situacao.key === 'A'}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                  <span>Valor Pagto</span>
                  <InputForm
                    type="number"
                    id="pgto_vlr_pago"
                    ref="pgto_vlr_pago"
                    value={pgto_vlr_pago}
                    onChange={this.onChangeParcela}
                    disabled={true}
                  />
                </Col>
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                <TipoDocFrame
                  label="Tipo Documento"
                  id="tparc_tipo_doc"
                  value={tparc_tipo_doc}
                  width={"100%"}
                  onChange={this.onChangeTipoDoc}
                  disabled={formParcDisabled}
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <CtaCorrenteFrame
                  label="Conta Corrente"
                  id="tparc_conta_corrente"
                  value={tparc_conta_corrente}
                  width={"100%"}
                  onChange={this.onChangeCtaCorrente}
                  disabled={formParcDisabled}
                />
              </Col>
            </Row>
          </Row>

          <Row style={{ marginBottom: 15, marginTop: 0 }}>
            <Col xs={24}>
              {condInformada ? (
                <Button
                  type="primary"
                  onClick={this.onAdicionarClick}
                  className="btn-primary"
                  style={{ float: "left", marginRight: 10, marginLeft: 15, width: 100 }}
                >
                  Novo
                </Button>
              ) : null}
              {formParcDisabled ? null : (
                <div>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.onOKParcClick}
                    className="btn-primary"
                    style={{ float: "right", marginRight: 10, marginLeft: 15, width: 150 }}
                  >
                    Salvar Parcela
                  </Button>

                  <Tooltip title="Voltar para Lista de Parcelas">
                    <Button
                      htmlType="button"
                      onClick={this.onCancelarParcClick}
                      className="btn-fechar"
                      style={{ float: "right", marginRight: 10, marginLeft: 15, width: 100 }}
                    >
                      Voltar
                    </Button>
                  </Tooltip>
                </div>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 50 }}>
            <div className="div-subTitulo" style={{ height: 30 }}>
              <Col xs={24} sm={6}>
                <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17, paddingTop: 5 }}>
                  Parcelas
                </span>
              </Col>
              {vlrDifParc === 0 ? null : (
                <span>
                  {/* <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}> */}
                  <Col xs={24} sm={6} style={{ marginTop: 5 }}>
                    <span style={{ fontWeight: "bold" }}>Valor Lançamento: </span>
                    <span>{this.renderValor(valor_Total)}</span>
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: 5 }}>
                    <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                    <span>{this.renderValor(vlrTotalParc)}</span>
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: 5 }}>
                    <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                    <span>{this.renderValor(vlrDifParc)}</span>
                  </Col>
                  {/* </Row> */}
                </span>
              )}
            </div>

            <Table
              dataSource={listaParcelas}
              pagination={false}
              rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
            >
              <Column
                key="tparc_parcela"
                dataIndex="tparc_parcela"
                title="Parcela"
                width={60}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="tparc_data_parcela"
                dataIndex="tparc_data_parcela"
                title="Data Venc"
                width={80}
                align="center"
                className="listaCadastro"
                render={this.renderData}
              />
              <Column
                key="tparc_valor"
                dataIndex="tparc_valor"
                title="Valor Parc"
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="situacao_parcela"
                dataIndex="situacao_parcela"
                title="Situação"
                width={80}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="td_descricao"
                dataIndex="td_descricao"
                title="Tipo Documento"
                width={200}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoesParcelas}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>

          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={onFecharClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TituloParcelaForm.js